import {
    ChangeDetectorRef,
    ElementRef,
    Component,
    OnDestroy,
    OnInit,
} from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Location } from "@angular/common";
import { Subject, forkJoin } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AppService } from "src/app/app.service";

@Component({
    selector: "app-dynamic-news-and-event",
    templateUrl: "./dynamic-news-and-event.component.html",
    styleUrls: ["./dynamic-news-and-event.component.scss"],
})
export class DynamicNewsAndEventComponent implements OnInit, OnDestroy {
    selectedItem: string = "";
    items = [
        { Name: "2024", Url: "2024" },
        { Name: "2023", Url: "2023" },
        { Name: "2022", Url: "2022" },
        { Name: "2021", Url: "2021" },
        { Name: "2020", Url: "2020" },
    ];
    imageLoaded = false;
    fetchinData = true;
    selectedItemName = "";
    private ngUnsubscribe = new Subject();
    AboutUs: any;
    twenty_four_data: any;
    twenty_four_school_data;
    twenty_four_high_school_data;
    twenty_four_college_data;
    twenty_three_data: any;
    twenty_three_school_data: any;
    twenty_three_college_data: any;
    twenty_three_high_school_data: any;
    twenty_two_data: any;
    twenty_two_school_data: any;
    twenty_two_high_school_data: any;
    twenty_two_college_data: any;
    twenty_one_data: any;
    twenty_one_school_data: any;
    twenty_one_high_school_data: any;
    twenty_one_college_data: any;
    twenty_data: any;
    twenty_school_data: any;
    twenty_college_data: any;
    twenty_high_school_data: any;
    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private appService: AppService,
        private router: Router,
        private _changeDetectorRef: ChangeDetectorRef
    ) {}
    ngOnInit() {
        this.route.paramMap.subscribe((params: ParamMap) => {
            const item = params.get("item");
            const matchedItem = this.items.find((i) => i.Url === item);
            if (item && matchedItem && item == matchedItem.Url) {
                this.selectedItem = item;
                this.selectedItemName = matchedItem.Name;
            } else {
                this.selectedItem = this.items[0].Url;
                this.selectedItemName = this.items[0].Name;
                this.location.replaceState(`/${this.selectedItem}`);
            }
            this.FetchData();
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }
    FetchData() {
        this._changeDetectorRef.markForCheck();
        this.fetchinData = true;
        if (
            this.selectedItem === "2020" ||
            this.selectedItem === "2021" ||
            this.selectedItem == "2022" ||
            this.selectedItem == "2023" ||
            this.selectedItem == "2024"
        ) {
            this.About_data();
        }
    }

    About_data() {
        forkJoin([this.appService.getContents()])
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((response: any) => {
                console.log(response, "All Response For About Us");

                this.AboutUs = response[0].data;
                console.log(this.AboutUs);

                if (this.AboutUs != null) {
                    // 2024
                    let twenty_four_college = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2024" &&
                            x.TitleEn == "College"
                    );
                    let twenty_four_school = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2024" &&
                            x.TitleEn == "School"
                    );
                    let twenty_four_high_school = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2024" &&
                            x.TitleEn == "High School"
                    );
                    this.twenty_four_college_data = twenty_four_college[0];
                    this.twenty_four_school_data = twenty_four_school[0];
                    this.twenty_four_high_school_data =
                        twenty_four_high_school[0];
                    console.log(
                        this.twenty_four_school_data,
                        "2024 School Data"
                    );
                    console.log(
                        this.twenty_four_high_school_data,
                        "2024 High School Data"
                    );
                    console.log(
                        this.twenty_four_college_data,
                        "2024 College Data"
                    );
                    // 2023
                    let twenty_college_three = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2023" &&
                            x.TitleEn == "College"
                    );
                    let twenty_high_school_three = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2023" &&
                            x.TitleEn == "High School"
                    );
                    let twenty_school_three = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2023" &&
                            x.TitleEn == "School"
                    );
                    this.twenty_three_college_data = twenty_college_three[0];
                    this.twenty_three_school_data = twenty_high_school_three[0];
                    this.twenty_three_high_school_data = twenty_school_three[0];
                    console.log(this.twenty_three_college_data, "2023 College");
                    console.log(this.twenty_three_school_data, "2023 School");
                    console.log(
                        this.twenty_three_high_school_data,
                        "2023 High SChool"
                    );
                    // 2022
                    let twenty_two_college = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2022" &&
                            x.TitleEn == "College"
                    );
                    let twenty_two_school = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2022" &&
                            x.TitleEn == "High School"
                    );
                    let twenty_two_high_school = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2022" &&
                            x.TitleEn == "School"
                    );
                    this.twenty_two_school_data = twenty_two_school[0];
                    this.twenty_two_college_data = twenty_two_college[0];
                    this.twenty_two_high_school_data =
                        twenty_two_high_school[0];
                    console.log(this.twenty_two_school_data, "2022 School");
                    console.log(this.twenty_two_college_data, "2022 College");
                    console.log(
                        this.twenty_two_high_school_data,
                        "2022 High School"
                    );
                    // 2021
                    let twenty_one_school = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2021" &&
                            x.TitleEn == "School"
                    );
                    let twenty_one_high_school = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2021" &&
                            x.TitleEn == "High School"
                    );
                    let twenty_one_college = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2021" &&
                            x.TitleEn == "College"
                    );

                    this.twenty_one_school_data = twenty_one_school[0];
                    this.twenty_one_high_school_data =
                        twenty_one_high_school[0];
                    this.twenty_one_college_data = twenty_one_college[0];

                    console.log(this.twenty_one_school_data, "2021 School");
                     console.log(this.twenty_one_high_school_data, "2021 High School");
                      console.log(this.twenty_one_college_data, "2021 College");
                    // 2020
                    let twenty_school = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2020" &&
                            x.TitleEn == "School"
                    );
                    let twenty_college = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2020" &&
                            x.TitleEn == "College"
                    );
                    let twenty_high_school = this.AboutUs.filter(
                        (x) =>
                            x.ContentCategoryName == "2020" &&
                            x.TitleEn == "High School"
                    );
                    this.twenty_school_data = twenty_school[0];
                    this.twenty_college_data = twenty_college[0];
                    this.twenty_high_school_data = twenty_high_school[0];
                    console.log(this.twenty_school_data, "2020 School");
                      console.log(this.twenty_college_data, "2020 College");
                        console.log(this.twenty_high_school_data, "2020 High School");

                }

                this.fetchinData = false;
            });
    }

    twenty_three(twenty_three: any, arg1: string) {
        throw new Error("Method not implemented.");
    }
    selectItem(item: string) {
        this.selectedItem = item;
        const matchedItem = this.items.find((i) => i.Url === item);
        this.selectedItemName = matchedItem.Name;
        if (this.selectedItem === "2024") {
            this.location.go(`/news/${item}`);
        } else if (this.selectedItem === "2023") {
            this.location.go(`/news/${item}`);
        } else if (this.selectedItem === "2022") {
            this.location.go(`/news/${item}`);
        } else if (this.selectedItem === "2021") {
            this.location.go(`/news/${item}`);
        } else if (this.selectedItem === "2020") {
            this.location.go(`/news/${item}`);
        } else {
            this.location.go(`/news_news`);
        }
    }
    TransformUrl(value) {
        if (value.includes("https://")) {
            return value;
        } else {
            return `https://${value}`;
        }
    }
}
